<script>
 export let navbarLinks;
</script>

<div class="flex justify-between bg-white sticky top-0 w-full z-40 p-2 items-baseline items-stretch text-base font-bold monocle:text-xs phone:text-xs">
    {#if !!(Object.keys(navbarLinks).indexOf("prev")+1) }
        <a href="#{navbarLinks.prev.href}" class="hover:underline items-start text-motw-blue">&lt;&lt;&nbsp;prev&nbsp;&nbsp&nbsp;&nbsp</a>
    {:else}
        <span class="text-white cursor-default select-none">&lt;&lt;prev&nbsp;&nbsp&nbsp;&nbsp</span>
    {/if}
    <span class="text-center text-black">{navbarLinks.searchStatus}</span>
    {#if !!(Object.keys(navbarLinks).indexOf("next")+1) }
        <a href="#{navbarLinks.next.href}" class="hover:underline text-motw-blue">&nbsp;&nbsp&nbsp;&nbsp;next&nbsp;&gt;&gt</a>
    {:else}
        <span class="text-white cursor-default select-nonE">&nbsp;&nbsp&nbsp;&nbsp;next&nbsp;&gt;&gt</span>
    {/if}
</div>
